import { forwardRef } from "react";

import { cn } from "@/lib/utils";

export interface ULThemeSelectProps
  extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label: string;
  options: string[];
  error?: boolean;
  isRequired?: boolean;
  placeholder?: string;
}

// Native <select>, styled to match ULThemeFloatingLabelField's input theme
// tokens closely enough for visual consistency — the floating-label
// primitive (components/ui/floating-label-field.tsx) is input-specific and
// not worth retrofitting for a handful of dropdowns.
const ULThemeSelect = forwardRef<HTMLSelectElement, ULThemeSelectProps>(
  ({ label, options, error, isRequired, placeholder, className, ...props }, ref) => {
    return (
      <div className="w-full mb-2">
        <label className="block text-sm mb-1 theme-universal:text-input-labels">
          {label}
          {isRequired && <span style={{ color: "#DC2626" }}>*</span>}
        </label>
        <select
          ref={ref}
          className={cn(
            "w-full h-14 px-3 theme-universal:bg-input-bg theme-universal:text-input-text theme-universal:rounded-input theme-universal:border-(length:--ul-theme-border-input-border-weight)",
            error ? "border-red-500" : "theme-universal:border-input-border",
            className
          )}
          {...props}
        >
          {placeholder && (
            <option value="" disabled>
              {placeholder}
            </option>
          )}
          {options.map((option) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </select>
      </div>
    );
  }
);

ULThemeSelect.displayName = "ULThemeSelect";

export default ULThemeSelect;
